/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-shadow */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useRef, useState } from 'react';
import { Button, Card, Breadcrumb, message, Input, Tooltip, Select } from 'antd';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { ReloadOutlined, MinusOutlined } from '@ant-design/icons';
import DrawerDriversVehicles from './DrawerDriversVehicles';
import { style } from '../../Styles';
import { deleteVehicle, getAllVehicles } from '../../redux/driversVehiclesSlice';
import ActionButton from '../Global/ActionsButton';
import { formatEnumValue } from '../../Utils/ArrayToObject';
import { getFullListDrivers } from '../../redux/driverSlice';
import CustomTableComponentsPageable from '../Global/CustomTableComponentsPageable';

const MAX_VISIBLE = 3;

/**
 * Shows up to MAX_VISIBLE tag chips. If there are more, a "+N" button
 * expands the row inline to reveal all, with a "Show less" link to collapse.
 */
const CollapsibleTags = ({ tags, tagStyle }) => {
	const [expanded, setExpanded] = useState(false);

	const toggle = (e) => {
		e.stopPropagation();
		setExpanded((v) => !v);
	};

	const onKeyDown = (e) => {
		if (e.key === 'Enter' || e.key === ' ') toggle(e);
	};

	const visible = expanded ? tags : tags.slice(0, MAX_VISIBLE);
	const hidden = tags.length - MAX_VISIBLE;

	return (
		<div style={{ display: 'flex', flexWrap: expanded ? 'wrap' : 'nowrap', gap: 6, alignItems: 'center' }}>
			{visible.map((t) => (
				<span key={t.key} style={tagStyle}>
					{t.label}
				</span>
			))}

			{!expanded && hidden > 0 && (
				<span
					role="button"
					tabIndex={0}
					onClick={toggle}
					onKeyDown={onKeyDown}
					style={{ cursor: 'pointer', background: 'rgba(0,0,0,0.06)', padding: '2px 8px', borderRadius: 4, fontSize: 12, flexShrink: 0 }}
				>
					+{hidden}
				</span>
			)}

			{expanded && (
				<span
					role="button"
					tabIndex={0}
					onClick={toggle}
					onKeyDown={onKeyDown}
					style={{ cursor: 'pointer', fontSize: 12, color: '#1677ff', flexShrink: 0 }}
				>
					Show less
				</span>
			)}
		</div>
	);
};

CollapsibleTags.propTypes = {
	tags: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
			label: PropTypes.string.isRequired,
		})
	).isRequired,
	tagStyle: PropTypes.shape({}),
};

CollapsibleTags.defaultProps = {
	tagStyle: {},
};

const DriversVehicles = () => {
	const [search, setSearch] = useState('');
	const searchTimerRef = useRef(null);
	const [selectedUser, setSelectedUser] = useState(null);
	const { Drivers } = useSelector((state) => state.drivers);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [sortBy, setSortBy] = useState('id');
	const [sortDirection, setSortDirection] = useState('DESC');
	const [displayDrawer, setDisplayDrawer] = useState(false);
	const [selectedDriversVehicles, setSelectedDriversVehicles] = useState(null);
	const [isMakingApiCall, setMakingApiCall] = useState(true);

	const dispatch = useDispatch();
	const { DriversVehicles } = useSelector((state) => state.driversVehicle);

	const handleTableChange = (_, __, sorter, extra) => {
		if (extra?.action !== 'sort') return;
		if (sorter.order) {
			setSortBy(sorter.columnKey || sorter.field);
			setSortDirection(sorter.order === 'ascend' ? 'ASC' : 'DESC');
		} else {
			setSortBy('id');
			setSortDirection('DESC');
		}
		setCurrentPage(1);
	};

	const columns = [
		{
			title: 'Vehicle',
			key: 'vehicle',
			render: (record) =>
				`${record.make?.deleted ? '-' : record.make?.name} ${record.model?.deleted ? '-' : record.model?.name} ${record.year}`,
			sorter: (a, b) => a.year - b.year,
			onCell: () => ({ style: { verticalAlign: 'top' } }),
			width: 200,
			multiple: 5,

		},
		{
			title: 'Driver',
			key: 'drivers',
			render: (record) => {
				const assigned = record.assignedDriverVehicles || [];
				if (assigned.length === 0) return <MinusOutlined />;
				const tags = assigned.map((a) => ({
					key: a.driver?.id,
					label: `${a.driver?.name} ${a.driver?.surname}`,
				}));
				return <CollapsibleTags tags={tags} tagStyle={style.tagsDriver} />;
			},
			onCell: () => ({ style: { verticalAlign: 'top' } }),
			width: 300,
		},
		{
			title: 'Available Seats',
			key: 'availableSeats',
			align: 'center',
			render: (record) => record.availableSeats,
			sorter: (a, b) => a.availableSeats - b.availableSeats,
			onCell: () => ({ style: { verticalAlign: 'top' } }),
			width: 150,
			multiple: 4,
		},
		{
			title: 'Fleet Operator',
			key: 'fleetOperator',
			render: (record) =>
				record.fleetOperator ? (
					<div>
						<span key={record.fleetOperator.id} style={style.tags}>
							{record.fleetOperator.name}
						</span>
						{!record.fleetOperator?.active && <span style={{ color: 'GrayText', fontSize: '12px' }}>(Inactive)</span>}
					</div>
				) : (


					<MinusOutlined />
				),
			sorter: (a, b) => (a.fleetOperator?.name || '').localeCompare(b.fleetOperator?.name || ''),
			onCell: () => ({ style: { verticalAlign: 'top' } }),
			width: 180,
			multiple: 1,
		},
		{
			title: 'Licence Plate',
			key: 'licencePlate',
			render: (record) => record.licencePlate,
			sorter: true,
			onCell: () => ({ style: { verticalAlign: 'top' } }),
			multiple: 3,
			width: 150,
		},
		{
			title: 'Vehicle Color',
			key: 'vehicleColor',
			render: (record) =>
				record.vehicleColor ? (
					<Tooltip title={record.vehicleColor}>
						<div style={{ backgroundColor: record.vehicleColor, borderRadius: '50%', width: '1.7em', height: '1.7em', margin: '0 auto' }} />
					</Tooltip>
				) : (
					'-'
				),
				sorter: true,
				onCell: () => ({ style: { verticalAlign: 'top' } }),
				width: 150,
				align: 'center',
		},
		{
			title: 'Vehicle Type',
			key: 'vehicleType',
			render: (record) => {
				const types = record.driverVehicleType || [];
				if (types.length === 0) return <MinusOutlined />;
				const tags = types.map((item) => ({
					key: item.id,
					label: formatEnumValue(item.vehicleType?.vehicleType),
				}));
				return <CollapsibleTags tags={tags} tagStyle={style.tags} />;
			},
			onCell: () => ({ style: { verticalAlign: 'top' } }),
			width: 300,
		},
		{
			title: 'Actions',
			key: 'actions',
			render: (text, record) => (
				<ActionButton
					record={record}
					onDelete={() => handleDeleteDriverVehicle(record.id, () => { })}
					onEdit={() => handleSelectedVehicle(record)}
					recordName={`${record.make?.name} ${record.model?.name} ${record.year}`}
				/>
			),
			onCell: () => ({ style: { verticalAlign: 'top' } }),
			width: 100,
		},
	];

	// Fetch all vehicles
	const fetchAll = () => {
		setMakingApiCall(true);
		dispatch(getAllVehicles({ driverId: selectedUser, page: currentPage - 1, size: pageSize, search, sortBy, sortDirection }))
			.unwrap()
			.catch(() => message.error('Failed to fetch drivers vehicles'))
			.finally(() => setMakingApiCall(false));
	};

	// Fetch all drivers
	const fetchAllDrivers = () => {
		dispatch(getFullListDrivers())
			.unwrap()
			.catch(() => message.error('Error fetching drivers'))
			.finally(() => setMakingApiCall(false));
	};

	useEffect(() => {
		fetchAllDrivers();
	}, [dispatch]);

	useEffect(() => {
		fetchAll();
	}, [dispatch, selectedUser, currentPage, pageSize, search, sortBy, sortDirection]);

	// Handle drawer
	const showDrawer = () => setDisplayDrawer(true);
	const onCloseDrawer = () => {
		setDisplayDrawer(false);
		setSelectedDriversVehicles({});
		fetchAll();
	};
	const handleSelectedVehicle = (vehicle) => {
		setSelectedDriversVehicles(vehicle);
		showDrawer();
	};

	const handleDeleteDriverVehicle = (id, callback) => {
		setMakingApiCall(true);
		dispatch(deleteVehicle({ vehicleId: id }))
			.unwrap()
			.then(() => {
				message.success('Vehicle deleted successfully');
				callback();
			})
			.finally(() => {
				onCloseDrawer();
				setMakingApiCall(false);
			});
	};

	// Add key for AntD table
	const driversVehiclesArray = DriversVehicles.driversVehiclesList.map((item) => ({ ...item, key: item.id }));

	return (
		<>
			<Card style={{ margin: 16, maxHeight: '90%', height: 'auto' }}>
				<div style={style.inlineContent}>
					<div style={{ display: 'flex', alignItems: 'center', float: 'left', marginBottom: 8 }}>
						<Breadcrumb
							style={{ margin: '0 3em 0 0', fontSize: '1.1em' }}
							items={[{ title: 'Vehicles' }, { title: 'Driver Vehicles' }]}
						/>
						<Button type="default" size="small" onClick={fetchAll}>
							<ReloadOutlined />
						</Button>
					</div>

					<div style={{ ...style.inlineContent, float: 'right', marginBottom: 8 }}>
						<Select
							placeholder="Select Driver"
							style={{ margin: '0 8px 8px 0', width: '13em' }}
							allowClear
							showSearch
							optionFilterProp="filterBy"
							optionLabelProp="label"
							onClear={() => setSelectedUser(null)}
							onChange={setSelectedUser}
						>
							{Drivers?.allDrivers?.map((item) => (
								<Select.Option
									key={item.id}
									value={item.id}
									label={<span>{`${item.name} ${item.surname}`}</span>}
									filterBy={`${item.name} ${item.surname}`}
								>
									<span>{`${item.name} ${item.surname}`}</span>
								</Select.Option>
							))}
						</Select>

						<Input.Search
							placeholder="Search"
							style={{ margin: '0 8px 8px 0', width: '13em' }}
							onSearch={(val) => {
								if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
								setCurrentPage(1);
								setSearch(val);
							}}
							onChange={(e) => {
								const val = e.target.value;
								if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
								searchTimerRef.current = setTimeout(() => {
									setCurrentPage(1);
									setSearch(val);
								}, 400);
							}}
						/>
						<Button
							type='default'
							style={{ float: 'right', marginBottom: 8 }}
							onClick={showDrawer}>
							Add Driver Vehicles
						</Button>
					</div>
				</div>

				<CustomTableComponentsPageable				
				    bordered					
					isMakingApiCall={isMakingApiCall}
					columns={columns}
					dataArray={driversVehiclesArray}
					handleDoubleClickRow={handleSelectedVehicle}
					handleSelectedRow={() => { }}
					onTableChange={handleTableChange}
					pagination={{
						current: currentPage,
						pageSize,
						total: DriversVehicles.total || 0,
						onChange: (page, size) => {
							setCurrentPage(page);
							setPageSize(size);
						},
					}}
				/>
			</Card>

			{displayDrawer && (
				<DrawerDriversVehicles
					handleDeleteDriverVehicle={handleDeleteDriverVehicle}
					onClose={onCloseDrawer}
					driversVehiclesId={selectedDriversVehicles?.id}
				/>
			)}
		</>
	);
};

export default DriversVehicles;

